/* global $ u ko */
// import {Get} from 'common'
import 'common/global.js'

function init (refer, obj) {
  let vm
  if (refer.options.data) {
    let data = refer.options.data
    vm = {
      data: ko.observableArray([
        {
          id: data.id.value,
          code: data.code.value,
          name: data.name.value,
          comItems: [{
            'value': '1',
            'name': '合格'
          }, {
            'value': '0',
            'name': '不合格'
          }],
          selectedvalue: data.status.value,
          supplyabilityId: data.supplyabilityId.value,
          supplyabilityName: data.supplyabilityName.value
        }
      ])
    }
  } else {
    vm = {
      data: ko.observableArray([
        {
          code: '',
          name: '',
          comItems: [{
            'value': '1',
            'name': '合格'
          }, {
            'value': '0',
            'name': '不合格'
          }],
          selectedvalue: 1
        }
      ])
    }
  }
  let app = u.createApp()
  app.init(vm, $('#new-norm-sorting')[0])
  refer.registerSubmitFunc(() => {
    return vm.data()
  })
}
let template = require('./index.html')
export default {
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/hierarchy/childGrid/index.js